import { ellipsis } from "@/common/style/commonStyle";
import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	container: {
		maxWidth: "750px",
		position: "relative",
		...shorthands.padding(tokens.spacingVerticalL),
	},
	popoverHeaderBiggerMargin: {
		marginBottom: "20px",
	},
	popoverHeaderLowerMargin: {
		marginBottom: "8px",
	},
	contactButton: {
		backgroundColor: tokens.colorNeutralBackground3,
		"&:hover": {
			backgroundColor: tokens.colorNeutralBackground3Hover,
		},
	},
	customerInfo: {
		marginBottom: "10px",
	},
	listTitle: {
		marginBottom: "5px",
	},
	listItemTime: {
		fontWeight: tokens.fontWeightSemibold,
		width: "138px",
		flex: "0 0 auto",
	},
	listItem: {
		backgroundColor: tokens.colorTransparentBackground,
		"&:hover": {
			backgroundColor: tokens.colorTransparentBackground,
		},
		cursor: "default",
		"& > span": {
			...ellipsis(),

			"&:not(:last-of-type)": {
				paddingRight: "20px",
			},
		},
		fontSize: "12px",
		paddingTop: "8px",
	},
	listItemIcon: {
		backgroundColor: tokens.colorTransparentBackground,
		paddingRight: "20px",
	},
	listItemEndMedia: {
		width: "60%",
	},
	listItemHandledIcon: {
		flex: "0 0 auto",
	},
	agentName: {
		maxWidth: "200px",
		flex: "0 0 auto",
	},
	contactMenuHeader: {
		color: tokens.colorNeutralForeground1,
	},
	messageContainer: {
		height: "60px",
	},
	closeButton: {
		paddingTop: "0",
		paddingRight: "0",
	},
});
